module.exports = __webpack_public_path__ + "cbf47ff6187e06e63e7fd4f056bf7252.pdf";